import { useState } from "react";
import { useLocation } from "react-router-dom";
import PortalAdmin from "./PortalAdmin";
import RecordsUpdater from "./RecordsUpdater";
import { PageHeader, SubTabs } from "../components/dc";
import usePageTitle from "../hooks/usePageTitle";

// Merged "Submissions" hub. Supplier Portal admin (which keeps its own internal
// Review Queue / Submissions / Suppliers / Settings tabs) and the Records Updater
// WMS/Kraken work queue, unified under one nav item. Both components are embedded
// whole, preserving every handler and API call. Legacy /portal-admin and
// /records-updater routes still resolve in App.js.
const TABS = [
  { key: "portal", label: "Supplier Portal" },
  { key: "records", label: "Records Updater" },
];

function initialTab(search, pathname) {
  const q = new URLSearchParams(search).get("tab");
  if (TABS.some((t) => t.key === q)) return q;
  if (pathname.includes("records-updater")) return "records";
  return "portal";
}

export default function SubmissionsHub() {
  usePageTitle("Submissions");
  const loc = useLocation();
  const [tab, setTab] = useState(() => initialTab(loc.search, loc.pathname));

  return (
    <div>
      <PageHeader title="Submissions" subtitle="Review supplier price submissions and work the WMS / Kraken records queue" />
      <div style={{ marginBottom: 20 }}>
        <SubTabs tabs={TABS} active={tab} onChange={setTab} />
      </div>
      {tab === "portal" && <PortalAdmin />}
      {tab === "records" && <RecordsUpdater />}
    </div>
  );
}
